import { render, staticRenderFns } from "./weather-watcher-settings.vue?vue&type=template&id=772de467"
import script from "./weather-watcher-settings.vue?vue&type=script&lang=js"
export * from "./weather-watcher-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports